import type { FunctionComponent } from "react"

import { isAfter } from "date-fns"
import { useParams } from "next/navigation"

import { Text } from "@jobteaser/spark/components/Text"
import IconCheck from "@jobteaser/ui-kit/assets/icons/jds_check.svg"
import { Note } from "@jobteaser/ui-kit/components/Note/Note"

import { WITHOUT_REGISTRATION } from "@/modules/events/constants"
import { useEventDetailsData } from "@/modules/events/hooks/useEventDetailsData"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./MainDetails.module.css"

export const EventStatus: FunctionComponent = () => {
  const { t } = useTranslation(["event_details"])
  const { eventSlug } = useParams<{ eventSlug: string }>()
  const event = useEventDetailsData(eventSlug)

  const currentDate = new Date()
  const endDate = new Date(event?.endDate || "")
  const isFinished = isAfter(currentDate, endDate)

  const isWithoutRegistration = event?.registrationDetails.type === WITHOUT_REGISTRATION

  if ((!isFinished && !isWithoutRegistration) || typeof event === "undefined") {
    return null
  }

  if (isFinished) {
    return (
      <Note variant="error" data-testid="event-details-main-details-finished">
        <Text variant="body1" weight="bold">
          {t("event_details.status.finished")}
        </Text>
      </Note>
    )
  }

  return (
    <div className={styles.eventStatus} data-testid="event-details-main-details-event-status">
      <Note
        variant="neutral"
        iconXlinkHref={`#${IconCheck.id}`}
        data-testid="event-details-main-details-without-registration"
      >
        <Text variant="body1" weight="bold">
          {t("event_details.registration.without")}
        </Text>
      </Note>
    </div>
  )
}
